module.exports = __webpack_public_path__ + "static/img/logo22.ccf634e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo22.jpg
// module id = ZQgB
// module chunks = 1